
  var _styles = {
  "slot-machine__container": {
    "width": "6.24rem",
    "borderRadius": "0.32rem",
    "backgroundColor": "rgb(248,248,248)"
  },
  "slot-machine__reels-container": {
    "flexDirection": "row",
    "justifyContent": "space-evenly",
    "alignItems": "flex-start",
    "height": "2.45333rem",
    "overflow": "hidden",
    "borderRadius": "0.21333rem",
    "width": "6.24rem"
  },
  "slot-machine__reel": {
    "overflow": "hidden",
    "width": "1.86667rem",
    "height": "2.4rem"
  }
};



  module.exports = _styles;
  